export default "__VITE_ASSET__DR23nNEI__"